import { Comment } from "@/components/comments/Comment.tsx";
import { FormResultForEmployeeProps } from "@/components/form-result/result-modal/components/types.ts";
import { CommentElement } from "@/components/questionnaire/components/CommentElement.tsx";
import { QuestionElementProps } from "@/components/questionnaire/components/element.type.ts";
import { getFormKey } from "@/components/questionnaire/questionnaire.types.ts";
import { Box, Stack, Textarea, Title, HtmlViewer } from "@skailer-com/uikit";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export const OpenAnswerElement: React.FC<QuestionElementProps> = ({ element }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation();

  const openAnswerSettings = element.open_answer_settings;
  if (!openAnswerSettings) return null;

  const formElementName = getFormKey(element);
  const hasError = !!errors[formElementName];

  return (
    <Stack gap={"2xl"} data-error={hasError || undefined}>
      {(openAnswerSettings.title || openAnswerSettings.description) && (
        <Stack gap="md">
          <Title
            header={openAnswerSettings.title || undefined}
            size={"md"}
            required={openAnswerSettings.is_required}
          />
          {openAnswerSettings.description && (
            <HtmlViewer content={openAnswerSettings.description} />
          )}
        </Stack>
      )}

      <Box>
        <Textarea
          {...register(formElementName)}
          label={t("common:enter_answer")}
          required={element.open_answer_settings?.is_required}
          error={errors[formElementName]?.message as string | undefined}
        />
      </Box>

      {openAnswerSettings.is_comment_enabled && <CommentElement element={element} />}
    </Stack>
  );
};

export const OpenAnswerElementResult = ({ element, answer }: FormResultForEmployeeProps) => {
  const { t } = useTranslation();
  const openAnswerSettings = element.open_answer_settings;
  if (!openAnswerSettings) return null;

  return (
    <>
      <Title
        header={openAnswerSettings.title || t("surveys:question_type_open_answer")}
        size={"sm"}
        paddingTop={true}
        className={openAnswerSettings.title ? "" : "text-secondary"}
      />

      <Stack gap={"md"} className={"mt-3"}>
        {answer ? (
          <Box
            className={"bg-dark/5 p-4 rounded-xs border border-brand-dark/5 whitespace-pre-wrap"}
          >
            {answer.answer_text}
          </Box>
        ) : undefined}
        {answer && answer.comment && (
          <Comment text={answer.comment} employee={null} isShort={false} />
        )}
      </Stack>
    </>
  );
};
